<header >
  <div class="sidenav" [ngClass]="collapsed ? 'sidenav-collapsed':''">
    <button type="button" #toggleButton class="fa fa-solid fa-bars" (click)="toggleCollapse()" style="cursor: pointer;padding:2px 8px 2px 8px;font-size: 25px;margin: 5px; background-color: #06223e; border:none">
       <!-- <i class="fa fa-solid fa-bars" style="font-size: 25px;margin: 5px; background-color: whitesmoke;"></i> -->
    </button>  
<!-- <img src="./menu.png"/> -->
   </div>
  <div class="row no-gutter">
    
    <div class="col-sm-2" >
      <!-- <fa-icon style="font-size: 30px;" [icon]='faBars'></fa-icon> -->
      <img class="img-responsive" src="../../../assets/images/login-logo-white.svg" alt="" />
    </div>
   <!-- <div > -->
    
   
    <!-- <div *ngIf='collapsed'>
      
        <ul class="sidebar-nav">
         
          <li class="sidebarName">
          
            <a>A</a>
            <a>B</a>
            <a>C</a>
            <a>D</a>
            <a>E</a>
       
          </li>
        </ul>
      
    </div> -->
    
    <div class="col-sm-10">
      <div class="header-name">
        <h4>Ways of Working</h4>
        
        <!-- <span class="navbar-toggler-icon"></span> -->
        
        
      </div>
      
      <div class="header-menu">
        <ul>
          <li class="dropdown">
            <a href="jaavscript:void(0)" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
              <span class="link-text">Hi {{name}}
                <i class="caret"></i>
              </span>
            </a>
            <ul class="dropdown-menu dropdown-menu-right">
              <li>
                <a (click)="logout();">Logout</a>
               
              </li>
            </ul>
          </li>
        </ul>
        <div class="clearfix"></div>
      </div>
     
      <div class="clearfix"></div>
      
    </div>
  </div>
  
</header>
<div class="menu" *ngIf='collapsed' [@myInsertRemoveTrigger]="collapsed?':leave':':enter'"  #menu>
   
  
  <amazon-sidebar (collap)='receive($event)'></amazon-sidebar>

<!-- </div> -->
 
</div>